import { GRADIENTJ_API_KEY } from "./constants";

export interface ChatHistoryEntry {
  speaker: "user" | "assistant" | "ehr_system";
  text: string;
}

export async function callGradientJStreamAPI({
  modelUUID,
  params,
  onStreamMessage,
}) {
  const GRADIENTJ_URL = "https://fast.gradientj.com/api/v0/deploy/inference";
  const headers = {
    "x-api-key": GRADIENTJ_API_KEY,
    "Content-Type": "application/json",
    Accept: "text/event-stream",
  };
  const body = {
    model: modelUUID,
    params: params,
    stream: true,
    use_azure: true,
  };

  const response = await fetch(GRADIENTJ_URL, {
    method: "POST",
    // cache: "no-cache",
    // keepalive: true,
    headers: headers,
    body: JSON.stringify(body),
  });

  if (!response.body) {
    throw new Error("Response body is empty");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";

  const results: string[] = [];
  while (true) {
    const { done, value } = await reader.read();

    if (done) {
      break;
    }
    buffer += decoder.decode(value, { stream: true });

    const messages = buffer.split("\r\n\r\n"); // Split buffer into messages at double newlines
    for (let i = 0; i < messages.length - 1; i++) {
      // Process all complete messages
      const lines = messages[i].split("\n");
      for (let line of lines) {
        if (line.startsWith("data:")) {
          const parsedMessage = line.replace("data: ", "").replace("\r", "\n");
          results.push(parsedMessage);
          if (!/{.*}/.test(parsedMessage)) {
            onStreamMessage(parsedMessage);
          }
        }
      }
    }
    buffer = messages[messages.length - 1];
  }

  const responseTextData = results.splice(0, results.length - 1);
  const completionObject = JSON.parse(results[results.length - 1]);

  const resultObj = {
    data: responseTextData,
    completionObject: completionObject,
    responseText: completionObject.completion,
  };

  return resultObj;
}
